var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.0132C6.62854 13.0132 3.75002 13.5522 3.75002 15.7058C3.75002 17.8585 6.61102 18.4169 10 18.4169C13.3707 18.4169 16.25 17.8779 16.25 15.7243C16.25 13.5708 13.389 13.0132 10 13.0132Z",
    fill: "#02291C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.962C12.2955 10.962 14.1356 9.09824 14.1356 6.77317C14.1356 4.44811 12.2955 2.5835 10 2.5835C7.70457 2.5835 5.86452 4.44811 5.86452 6.77317C5.86452 9.09824 7.70457 10.962 10 10.962Z",
    fill: "#DCE3DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.286c542f.svg";
export { ForwardRef as ReactComponent };